export const registerComponents = (Vue, components) => {
  for (var component of components) {
    Vue.component(
      `Vp${Object.keys(component)[0]}`,
      Object.values(component)[0]
    );
  }
};
